String.prototype.lastIndexOf = function(searchValue, start) {

    const str = this;
    const searchLen = searchValue.length;
    const strLen = str.length;

    // 空字符串的特殊情况
    if (searchLen === 0) {
        if (start === undefined) return strLen;
        start = Number(start);
        if (isNaN(start)) return 0;
        start = Math.max(0, Math.min(Math.floor(start), strLen));
        return start;
    }

    // 处理 start 参数
    if (start === undefined) {
        start = strLen - searchLen;
    } else {
        start = Number(start);
        if (isNaN(start)) start = 0;
        start = Math.floor(start);
        start = Math.min(start, strLen - searchLen);
    }
    start = Math.max(0, start);

    // 从后向前查找
    for (let i = start; i >= 0; i--) {
        let match = true;
        for (let j = 0; j < searchLen; j++) {
            if (str[i + j] !== searchValue[j]) {
                match = false;
                break;
            }
        }
        if (match) {
            return i;
        }
    }

    return -1; // 未找到
};